import { ViewModel } from '../view-model';
import { CommercialImpactInput } from './commercial-impact-input';

export class CommercialImpactItem implements ViewModel {
  friendlyTypeNameSingular: string = 'Commercial Impact Item';
  apiRoute: string;

  id: string;
  inputs: CommercialImpactInput[] = [];
  totalValue: number;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;

    if (data.inputs) {
      this.inputs = data.inputs;
    }

    this.totalValue = data.totalValue;
  }
}
